<template>
	<div id="app">
		<!-- 根据路由判断是否显示导航栏等组件 -->
		<div v-if="!isLoginPage">
			<!-- 顶部导航栏组件 -->
			<TopNavBar v-if="shopStatus == 1 || !shopStatus" />
			<TopNavBarH v-else />

			<!-- 主要内容区域 -->
			<main class="main-content" v-if="shopStatus == 1 || !shopStatus">
				<router-view />
			</main>
			<div class="painter-content" v-else>
				<PainterSidebar />
				<main class="painter-main-content">
					<router-view />
				</main>
			</div>
			<!-- 底部导航栏组件 -->
			<BottomNavBar />

			<MsgSever class="msgSever" />
			<MsgSeverPhone class="msgSeverPhone" />
		</div>
		<!-- 登录页单独展示 -->
		<div v-else>
			<router-view />
		</div>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	import TopNavBar from './components/TopNavBar.vue'
	import TopNavBarH from './components/TopNavBarH.vue'
	import PainterSidebar from './components/PainterSidebar.vue'
	import BottomNavBar from './components/BottomNavBar.vue'
	import MsgSever from './components/MsgSever.vue'
	import MsgSeverPhone from './components/MsgSeverPhone.vue'

	export default {
		name: 'App',
		components: {
			TopNavBarH,
			TopNavBar,
			PainterSidebar,
			BottomNavBar,
			MsgSever,
			MsgSeverPhone
		},
		computed: {
			...mapState(['shopStatus']),
			// 判断当前是否为登录页
			isLoginPage() {
				return this.$route.path === '/register' || this.$route.path === '/login' || this.$route.path ===
					'/personal-like';
			}
		},
		watch: {
			$route: {
				handler(to, from) {
					if (to.path == '/') {
						if (this.shopStatus == 2 || !this.shopStatus) {
							localStorage.clear();
							this.$store.dispatch('updateShopStatus', 1)
						}
					}
					console.log('当前路由:', to);
					console.log('之前的路由:', from);
				},
				deep: true, // 深度监听（可选）
				immediate: true // 初始化时立即触发（可选）
			}
		},
	}
</script>

<style>
	/* 全局样式重置 */
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	body {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
	}

	#app {
		/* min-height: 100vh; */
		display: flex;
		flex-direction: column;
	}

	/* 主要内容区域样式 */
	.main-content {
		background: rgba(8, 8, 8, 1);
		min-height: calc(100vh - 3.15rem);
	}

	.painter-content {
		display: flex;
	}

	.painter-main-content {
		height: calc(100vh - 3.18rem);
		width: calc(100% - 2.56rem);
		background: #FAEFDD;
		overflow-y: auto;
	}

	@media (max-width: 480px) {
		.msgSever {
			display: none;
		}

		.msgSeverPhone {
			display: block;
		}
	}

	@media (min-width: 481px) {
		.msgSever {
			display: block;
		}

		.msgSeverPhone {
			display: none;
		}
	}
</style>